module.exports = __webpack_public_path__ + "static/media/modal_logo.e3b5a994.png";